import styled, { css } from 'styled-components';
import { FLEX_GAP } from './consts';
import {
  VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME,
  EXPORT_AUTOSIZE_CLASS_NAME,
} from '@ardoq/global-consts';
import { classes } from '@ardoq/common-helpers';
import { DEPENDENCY_MAP_NODES_CONTAINER_PADDING } from '@ardoq/global-consts';

type NodesContainerProperties = {
  $showVertical: boolean;
  $ariaLabel?: string;
};
export const NodesContainer = styled.div.attrs<NodesContainerProperties>(
  props => ({
    className: classes(
      VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME,
      EXPORT_AUTOSIZE_CLASS_NAME,
      props.className
    ),
    'aria-label': props.$ariaLabel ?? 'Dependency map',
    role: 'tree',
  })
)<NodesContainerProperties>`
  height: 100%;
  width: 100%;
  overflow: auto;
  padding: ${DEPENDENCY_MAP_NODES_CONTAINER_PADDING}px;
  line-height: 1.4;
  display: flex;
  ${({ $showVertical }) => css`
    flex-wrap: ${$showVertical ? 'wrap' : undefined};
    flex-direction: ${$showVertical ? 'row' : 'column'};
    justify-content: flex-start;
    gap: ${FLEX_GAP}px;
  `}

  .forExport & {
    overflow: visible;
  }
`;
